<template>
    <div class="ts-client" v-tooltip="'Database id: ' + client.dbid">
        <progressive-img
            class="avatar"
            :src="prefix + '/assets/avatars/' + client.dbid + '.png'"
            :fallback="prefix + '/assets/fallbacks/avatar.jpg'"
        />
        <span v-if="badge != `none`" :class="'badge badge-' + badge">{{ client.nick }}</span>
        <span v-else style="margin-left: 10px">{{ client.nick }}</span>
    </div>
</template>

<script>
    export default {
        name: "Client",
        props: {
            client: Object,
            badge: {
                type: String,
                default: function () {
                    return "info"
                }
            }
        },
        computed: {
            prefix() {
                return process.env.NODE_ENV !== 'development' ? '' : 'http://51.75.37.170:2000';
            }
        }
    }
</script>

<style scoped>
    .ts-client {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        margin: 3px;
        justify-content: flex-start;
        align-items: center;
    }

    .ts-client .avatar {
        position: relative;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
        margin-right: 6px;
    }

    .ts-client-a:hover {
      text-decoration: none;
    }
</style>